import { jsx as t, jsxs as c, Fragment as A } from "react/jsx-runtime";
import { QUERIES as i, BREAKPOINTS as l } from "@fcamna/shared-component-foundations";
import { fordProIcons as B } from "@fcamna/shared-icons";
import V, { useState as U, useEffect as H } from "react";
import n, { css as I } from "styled-components";
import { u as w } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { IconButton as S } from "./iconButton.js";
import { MediaDisclosureButton as P } from "./mediaDisclosureButton.js";
import { u as O } from "./useWindowDimensions-ae69e913.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
const { PlayFilled: G } = B, T = "218px", z = "436px", R = "689px", D = n.div`
  ${({ theme: { componentStyles: e } }) => I(e)};
  display: ${(e) => e.theme.components.blogVideo.Wrapper.display};
  flex-direction: ${(e) => e.theme.components.blogVideo.Wrapper.flexDirection};
  max-width: ${(e) => e.theme.components.blogVideo.Wrapper.maxWidth};
  margin: ${(e) => e.theme.components.blogVideo.Wrapper.margin};
  width: ${(e) => e.theme.components.blogVideo.Wrapper.width};
`, k = n.div`
  color: ${(e) => e.theme.components.blogVideo.HeadlineWrapper.color};
  font-size: ${(e) => e.theme.components.blogVideo.HeadlineWrapper.fontSize};
  font-family: ${(e) => e.theme.components.blogVideo.HeadlineWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.blogVideo.HeadlineWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.blogVideo.HeadlineWrapper.lineHeight};
`, _ = n.div`
  margin-top: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.marginTop};
  color: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.color};
  font-size: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.fontSize};
  font-family: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.lineHeight};

  @media ${i.tabletAndUp} {
    margin-top: ${(e) => e.theme.components.blogVideo.SubheadlineWrapper.tabletAndUp.marginTop};
  }
`, F = n.div`
  margin-top: ${(e) => e.theme.components.blogVideo.BodyWrapper.marginTop};
  color: ${(e) => e.theme.components.blogVideo.BodyWrapper.color};
  font-size: ${(e) => e.theme.components.blogVideo.BodyWrapper.fontSize};
  font-family: ${(e) => e.theme.components.blogVideo.BodyWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.blogVideo.BodyWrapper.fontWeight};
  line-height: ${(e) => e.theme.components.blogVideo.BodyWrapper.lineHeight};
`, M = n.div`
  margin-top: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.marginTop};
  position: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.position};
  background: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.background};
  border-radius: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.borderRadius};
  max-height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.maxHeight};
  min-height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.minHeight};
  height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.height};

  iframe {
    border-radius: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.iframe.borderRadius};
  }

  @media ${i.tabletAndUp} {
    margin-top: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.marginTop};
    border-radius: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.borderRadius};
    min-width: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.minWidth};
    height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.height};
    max-height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.maxHeight};

    iframe {
      border-radius: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.tabletAndUp.iframe.borderRadius};
    }
  }

  @media ${i.laptopAndUp} {
    height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.laptopAndUp.height};
    max-height: ${(e) => e.theme.components.blogVideo.VideoContainerWrapper.laptopAndUp.maxHeight};
  }
`, j = n.img`
  background: ${(e) => e.theme.components.blogVideo.CoverImageElement.background};
  position: ${(e) => e.theme.components.blogVideo.CoverImageElement.position};
  border-radius: ${(e) => e.theme.components.blogVideo.CoverImageElement.borderRadius};
  cursor: ${(e) => e.theme.components.blogVideo.CoverImageElement.cursor};
  max-width: ${(e) => e.theme.components.blogVideo.CoverImageElement.maxWidth};
  width: ${(e) => e.theme.components.blogVideo.CoverImageElement.width};
  height: ${(e) => e.theme.components.blogVideo.CoverImageElement.height};
  object-fit: ${(e) => e.theme.components.blogVideo.CoverImageElement.objectFit};

  @media ${i.tabletAndUp} {
    border-radius: ${(e) => e.theme.components.blogVideo.CoverImageElement.tabletAndUp.borderRadius};
    height: ${(e) => e.theme.components.blogVideo.CoverImageElement.tabletAndUp.height};
    max-height: ${(e) => e.theme.components.blogVideo.CoverImageElement.tabletAndUp.maxHeight};
  }

  @media ${i.laptopAndUp} {
    height: ${(e) => e.theme.components.blogVideo.CoverImageElement.laptopAndUp.height};
    max-height: ${(e) => e.theme.components.blogVideo.CoverImageElement.laptopAndUp.maxHeight};
  }
`, L = n(S)`
  && {
    position: ${(e) => e.theme.components.blogVideo.PlayButtonElement.position};
    left: ${(e) => e.theme.components.blogVideo.PlayButtonElement.left};
    bottom: ${(e) => e.theme.components.blogVideo.PlayButtonElement.bottom};
    z-index: ${(e) => e.theme.components.blogVideo.PlayButtonElement.zIndex};

    @media ${i.tabletAndUp} {
      left: ${(e) => e.theme.components.blogVideo.PlayButtonElement.tabletAndUp.left};
      bottom: ${(e) => e.theme.components.blogVideo.PlayButtonElement.tabletAndUp.bottom};
    }
  }
`, N = n.div`
  width: ${(e) => e.theme.components.blogVideo.GradientOverlay.width};
  height: ${(e) => e.theme.components.blogVideo.GradientOverlay.height};
  z-index: ${(e) => e.theme.components.blogVideo.GradientOverlay.zIndex};
  position: ${(e) => e.theme.components.blogVideo.GradientOverlay.position};
  border-radius: ${(e) => e.theme.components.blogVideo.GradientOverlay.borderRadius};
  cursor: ${(e) => e.theme.components.blogVideo.GradientOverlay.cursor};

  background: ${(e) => e.theme.components.blogVideo.GradientOverlay.background};
  @media ${i.tabletAndUp} {
    border-radius: ${(e) => e.theme.components.blogVideo.GradientOverlay.tabletAndUp.borderRadius};
  }
`;
function Q({ children: e, ...o }) {
  return /* @__PURE__ */ t(k, { ...o, children: e });
}
function q({ children: e, ...o }) {
  return /* @__PURE__ */ t(_, { ...o, children: e });
}
function K({ children: e, ...o }) {
  return /* @__PURE__ */ t(F, { ...o, children: e });
}
function J({
  shouldShowGradientOverlay: e = !0,
  coverImage: o,
  onClick: a,
  children: u,
  playButtonSize: $ = "medium",
  disclosureLinks: h,
  accessibilityOptions: f = { ariaLabel: "Play" },
  ...W
}) {
  const y = w({ label: "Blog Video" }), [s, C] = V.useState(!!o), [x, v] = V.useState(!0), g = {
    right: ["108px", "108px", "20px"],
    bottom: ["25px", "14px", "8px"]
  };
  function p(E) {
    a == null || a(E), C(!1), v(!1);
  }
  const [b, d] = U(0), { width: m } = O();
  return H(() => {
    m > l.laptopMin ? d(0) : m < l.laptopMin && m > l.tabletMin ? d(1) : d(2);
  }, [m]), /* @__PURE__ */ c(
    M,
    {
      ...W,
      ...y,
      children: [
        s && /* @__PURE__ */ c(A, { children: [
          /* @__PURE__ */ t(
            L,
            {
              accessibilityOptions: f,
              icon: /* @__PURE__ */ t(G, { "aria-hidden": !0 }),
              onClick: p,
              size: $
            }
          ),
          e && /* @__PURE__ */ t(
            N,
            {
              "aria-hidden": "true",
              onClick: p
            }
          ),
          /* @__PURE__ */ t(
            j,
            {
              "aria-hidden": "true",
              src: o,
              onClick: p
            }
          )
        ] }),
        h && x && /* @__PURE__ */ t(
          P,
          {
            ...h,
            alignment: "bottom-right",
            containerPosition: {
              bottom: g.bottom[b],
              right: g.right[b]
            }
          }
        ),
        /* @__PURE__ */ t("div", { "aria-hidden": s ? "true" : "false", children: u })
      ]
    }
  );
}
function r({ children: e, ...o }) {
  return /* @__PURE__ */ t(D, { ...o, children: e });
}
r.Headline = Q;
r.Subheadline = q;
r.Body = K;
r.VideoContainer = J;
r.mobileHeight = T;
r.tabletHeight = z;
r.laptopAndUpHeight = R;
export {
  r as BlogVideo
};
